import { render, staticRenderFns } from "./AudiencePage.vue?vue&type=template&id=8bb2e368&scoped=true"
import script from "./AudiencePage.vue?vue&type=script&lang=js"
export * from "./AudiencePage.vue?vue&type=script&lang=js"
import style0 from "./AudiencePage.vue?vue&type=style&index=0&id=8bb2e368&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb2e368",
  null
  
)

export default component.exports